import React, { ReactElement } from 'react'
import './App.css'
import { ThemeProvider } from 'styled-components'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import theme from '../theme'
import ProtectedRoutes from '../screens/ProtectedRoutes'
import { ConnectedUserProvider } from '../contexts/connected-user'
import { AddTextAdminProvider } from '../contexts/add-text-admin'
import Dashboard from '../screens/admin/dashboard'
import Connexion from '../screens/connexion'
import TrainingRoutes from '../screens/trainingRoutes'

function App(): ReactElement {
  return (
    <ConnectedUserProvider>
      <ThemeProvider theme={theme}>
        <AddTextAdminProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Connexion />} />
              <Route element={<ProtectedRoutes />}>
                <Route path="/trainings" element={<TrainingRoutes />} />
                <Route path="/dashboard" element={<Dashboard />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </AddTextAdminProvider>
      </ThemeProvider>
    </ConnectedUserProvider>
  )
}

export default App
